import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import classnames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import { Typography } from '@material-ui/core';

function SidebarButton(props){
    // static propTypes = {
    //     classes: PropTypes.object.isRequired,
    //     title: PropTypes.string,
    //     tooltip: PropTypes.bool,
    //     disabled: PropTypes.bool,
    //     placement: PropTypes.oneOf(['top', 'bottom']),
    //     icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    //     onClick: PropTypes.func,
    //     name: PropTypes.string,
    //     active: PropTypes.bool,
    //     badge: PropTypes.bool
    // }; //update when converting to typescript 
    const { classes, icon, title, disabled = false, tooltip = false, name = '', active, badge = false } = props;
    const [state, setState] = useState({open:false});
    

    const handleClick = event => {
        props.onClick(event);
    };

    return (
        <div>
            <Tooltip
                classes={{ popper: classes.popper }}
                title={tooltip ? title : ''}
                placement="right"
            >
                <div>
                    <Button
                        data-intercom-target={`${title.replace(/ /g,"-").toLowerCase()}-side-navigation-button`}
                        classes={{
                            root: classnames(classes.button, active && classes.active),
                            disabled: classes.disabled
                        }}
                        className={classes.button}
                        disabled={disabled}
                        onClick={handleClick}
                        name={name}
                    >
                        <div className={classnames(classes.iconbg)}>
                            <Icon className={classes.icon} >
                                {icon}
                            </Icon>
                        </div>
                        <Typography
                            className={classes.title}
                        >
                            {title}
                        </Typography>
                        {badge && <span className={classes.badge} />}
                    </Button>
                </div>
            </Tooltip>
        </div>
    );
}

const style = theme => ({
    button: {
        borderRadius: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'nowrap',
        width: '100%',
        minWidth: 'auto',
        padding: '0px',
        overflowX: 'hidden',
        color: theme.palette.grey.variant5
    },
    active: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.light
    },
    disabled: {
        color: theme.palette.grey.variant3
    },
    iconbg: {
        minHeight: theme.constants.sidebarNavigationWidth,
        minWidth: theme.constants.sidebarNavigationWidth,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    title: {
        textAlign: 'left',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        // fontFamily: '"Montserrat", sans-serif',
        fontSize: '14px',
        textTransform: 'uppercase'
    },
    tooltipPlacementLeft: {
        margin: 50
    },
    popper: {
        zIndex: 200
    },
    imageIcon: {
        minWidth: 44,
        width: 44,
        padding: '0 10px',
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    badge: {
        position: 'absolute',
        top: 6,
        left: 38,
        width: 12,
        height: 12,
        backgroundColor: '#EA1B1B',
        borderRadius: '50%'
    }
});

export default withStyles(style)(SidebarButton);